/*
** 스크립트 정의
*/
const sidebarModule = {
  init: function() {
    document.addEventListener('DOMContentLoaded', () => {
      this.set_sticky_scroll()
    });
  },
  set_sticky_scroll: function () {

    const adminbar = document.querySelector('#wpadminbar');
    const sidebar = document.querySelector('.sidebar');
    const footer = document.querySelector('footer');
    const parent = sidebar ? sidebar.closest('.wp-block-column') : null;
    if (sidebar && footer && parent) {
      
      parent.style.position = 'relative';
      const scroll_gap = adminbar ? adminbar.offsetHeight : 0 ;
      const sticky_top = sidebar.dataset.stickytop || '' ;
      const doc = document;
      const document_height = Math.max(
        doc.body.scrollHeight, doc.documentElement.scrollHeight,
        doc.body.offsetHeight, doc.documentElement.offsetHeight,
        doc.body.clientHeight, doc.documentElement.clientHeight
      );

      const layout = document.querySelector('.layout-page');
      const layoutStyle = layout ? window.getComputedStyle(layout, null) : null ;
      const layoutHeight = (sidebarHeight) => {
        const h = layoutStyle ? layout.clientHeight - parseFloat(layoutStyle.paddingTop) - parseFloat(layoutStyle.paddingBottom) : 0 ;
        if (h > sidebarHeight * 1.2) {
          return true;
        } else {
          return false;
        }
      }

      // 사이드바 UI가 확인되면
      if (sidebar) {

        // 가상 위치를 찾기 위한 로직 ------------------------------------------------------------
        const layout = document.querySelector('.layout-page');
        let layout_gap = 0;
        if (layout) {
            const paddingBottom = getComputedStyle(layout).paddingBottom;
            layout_gap = parseFloat(paddingBottom) || 0;
        }

        const sticky_dom = document.createElement('div');
        sticky_dom.style.position = 'fixed';
        sticky_dom.style.top = sticky_top;
        sticky_dom.style.width = '1px';  // 크기를 최소화하여 문서 레이아웃에 영향을 주지 않도록 설정
        sticky_dom.style.height = '1px';
        sticky_dom.style.opacity = '0';  // 보이지 않게 설정
        document.body.appendChild(sticky_dom);
        const sticky_top_num = sticky_dom.getBoundingClientRect().top || 0 ;
        // -------------------------------------------------------------------------------------

        let fixedY = sticky_top_num;

        // debounce 함수 정의
        function debounce(func, wait) {
          let timeout;
          return function(...args) {
            const later = () => {
              clearTimeout(timeout);
              func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
          };
        }

        // 스로틀링 함수 정의
        function throttle(func, delay) {
          let lastTime = 0;
          return function(...args) {
            const now = new Date().getTime();
            if (now - lastTime >= delay) {
              func.apply(this, args);
              lastTime = now;
            }
          };
        }

        // 이벤트 등록
        window.addEventListener('scroll', (event) => {

          const parent_rect = parent.getBoundingClientRect();
          const sidebar_rect = sidebar.getBoundingClientRect();
          const footer_rect = footer.getBoundingClientRect();
          const min_height = document_height - parent_rect.top - footer_rect.height;
          const meet_footer = window.scrollY + sidebar_rect.height + fixedY > footer_rect.top + window.scrollY;

          // meet footer
          if (meet_footer && layoutHeight(sidebar_rect.height)) {

            parent.style.minHeight = sidebar_rect.height + 'px';
            
            sidebar.style.top = `unset`;
            sidebar.style.bottom = `-${layout_gap}px`;
            sidebar.style.width = sidebar_rect.width ? `${sidebar_rect.width}px` : '' ;
            sidebar.classList.add('active');
            sidebar.classList.add('absolute');
            sidebar.classList.remove('fixed');

            sidebar.style.transform = '';

          // meet sidebar
          } else if (layoutHeight(sidebar_rect.height) && window.scrollY > parent_rect.top + window.scrollY && min_height > sidebar_rect.height) {

            parent.style.minHeight = sidebar_rect.height + 'px';

            sidebar.style.top = `${scroll_gap}px`;
            sidebar.style.width = sidebar_rect.width ? `${sidebar_rect.width}px` : '' ;
            sidebar.style.bottom = `unset`;
            sidebar.classList.add('fixed');
            sidebar.classList.remove('absolute');

            // sidebar.style.transform = `translateY(${sticky_top})`;

            // fixedY = sidebar_rect.top > 0 ? sidebar_rect.top : 0 ;

          } else {

            parent.style.minHeight = `unset`;

            sidebar.classList.remove('active');
            sidebar.classList.remove('fixed');
            sidebar.classList.remove('absolute');
            sidebar.style.top = `unset`;
            sidebar.style.bottom = `unset`;

            sidebar.style.transform = '';

          }
          
        });

        // 강제 이벤트 생성
        const event = new Event('scroll');
        window.dispatchEvent(event);

        // 리사이즈 핸들러 정의
        const handleImmediateResize = throttle(() => {
          // reRendering(wrapper, element, posTop, posLeft, posRight, posTiming);
        }, 0); // 즉시 실행

        const handleDebouncedResize = debounce(() => {
          window.dispatchEvent(event);
        }, 300); // 500ms 이후에 실행

        // 리사이즈 이벤트 리스너 추가
        window.addEventListener('resize', () => {
          // handleImmediateResize();
          handleDebouncedResize();
        });

      };

    }

  }
};
sidebarModule.init();